<template>
  <span class="regulation-selection">{{ this.text }}</span>
</template>

<script>
export default {
  name: 'RegulationSelection',
  props: {
    text: {
      type: String,
      required: true,
    },
    isLastElement: {
      type: Boolean,
      default: false,
    },
    isFirstElement: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import '~@/assets/styles/design-system';

.regulation-selection {
  margin-left: $space-1-5;
  color: $auth-text-primary;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: $font-size-md;
}

.regulation-selection::after {
  content: ',';
}
</style>
